// @flow
import React, { Component } from 'react'
import styled from 'styled-components/macro'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { resetErrorMessage } from 'store/actions/error'

import AlertModal from 'components/modals/AlertModal'
import { t } from 'ttag'
import SearchComponent from 'components/SearchComponent'
import ResultsComponent from 'components/ResultsComponent'
import InfoModal from 'components/modals/InfoModal'
import PropTypes from 'prop-types'

const FilterToggle = styled.div`
  background-color: rgba(255, 109, 16, 1);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  color: white;
  height: 80px;
  width: 60px;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 300px;
  cursor: pointer;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  display: ${props => (props.isSidebarVisible ? 'none' : 'block')};
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    background-color: rgb(255, 117, 29);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
  }
`

const Container = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
`

const SearchIcon = styled.i`
  font-size: 24px;
  margin: 10px;
  cursor: pointer;
`

class Search extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isSidebarVisible: true,
      location: {
        hasPermission: false,
        hasResults: true,
        coords: null
      },
      currentFilters: []
    }

    this.handleSetCurrentFilters = this.handleSetCurrentFilters.bind(this)
    this.handleLocationPermissionResult = this.handleLocationPermissionResult.bind(this)
    this.toggleFilterSidebar = this.toggleFilterSidebar.bind(this)
  }

  moveToTop() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search)
    const hideParam = urlParams.get('hide-sidebar')
    const programmeParam = urlParams.get('programme_id')
    if (hideParam || programmeParam) {
      this.setState({ isSidebarVisible: false })
    }
  }

  toggleFilterSidebar() {
    const { isSidebarVisible } = this.state
    this.setState(prevState => ({
      isSidebarVisible: !prevState.isSidebarVisible
    }))
    const crumbs = document.getElementById('crumbs')
    if (crumbs) {
      crumbs.style.left = !isSidebarVisible ? '450px' : '70px'
    }
    this.moveToTop()
  }

  handleLocationPermissionResult(permissionResult) {
    const { location } = this.state
    location.hasPermission = permissionResult
    this.setState({ location })
  }

  handleLocationSearchResult(hasResults) {
    const { location } = this.state
    location.hasResults = hasResults
    this.setState({ location })
  }

  handleSetCurrentFilters(currentFilters) {
    this.setState({ currentFilters })
  }

  render() {
    const {
      // eslint-disable-next-line no-unused-vars
      searchPage,
      filters: { currentSearchable, selectedFilters, resultHash }
    } = this.props
    const { isSidebarVisible, location, currentFilters } = this.state

    return (
      <div className="App">
        <FilterToggle isSidebarVisible={isSidebarVisible} onClick={this.toggleFilterSidebar}>
          <SearchIcon className="far fa-search" />
          {t`Modify filters`}
        </FilterToggle>
        <Container>
          <SearchComponent
            searchPage={searchPage}
            isSidebarVisible={isSidebarVisible}
            onToggleSideBar={this.toggleFilterSidebar}
            onLocationPermissionResult={this.handleLocationPermissionResult}
            setCurrentFilters={this.handleSetCurrentFilters}
            currentFilters={currentFilters}
          />
          <ResultsComponent
            currentSearchable={currentSearchable}
            isSidebarVisible={isSidebarVisible}
            location={location}
            currentFilters={currentFilters}
            selectedFilters={selectedFilters}
            resultHash={resultHash}
          />
        </Container>
        <InfoModal />
        <AlertModal />
      </div>
    )
  }
}

Search.propTypes = {
  searchPage: PropTypes.string,
  filters: PropTypes.shape({
    currentSearchable: PropTypes.string,
    selectedFilters: PropTypes.object,
    resultHash: PropTypes.string
  })
}

const mapStateToProps = ({ error, filters }) => ({
  error,
  filters
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetErrorMessage
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Search)
